import { c as _c } from "react/compiler-runtime";
import { Star } from "lucide-react";
import { cn } from "@/lib/utils";
type Props = {
  rating: number;
  reviewCount?: number | null;
  className?: string;
  starClassName?: string;
};
export function Rating(t0) {
  const $ = _c(17);
  const {
    rating,
    reviewCount,
    className,
    starClassName
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-1.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = Array.from({
      length: 5
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== rating || $[4] !== starClassName) {
    t3 = <div className="flex items-center gap-0.5">{t2.map((_, i) => <Star key={i} data-testid="rating-star" className={cn("w-3.5 h-3.5", i < Math.round(rating) ? "fill-amber-400 text-amber-400" : "text-zinc-300", starClassName)} />)}</div>;
    $[3] = rating;
    $[4] = starClassName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== rating) {
    t4 = rating.toFixed(1);
    $[6] = rating;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t4) {
    t5 = <span className="text-sm font-medium text-zinc-700">{t4}</span>;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== reviewCount) {
    t6 = reviewCount != null && <span className="text-xs text-zinc-400">({reviewCount})</span>;
    $[10] = reviewCount;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t1 || $[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div data-testid="rating" className={t1} data-sentry-component="Rating" data-sentry-source-file="Rating.tsx">{t3}{t5}{t6}</div>;
    $[12] = t1;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}